import { memo } from 'react';
import { Stack } from '@chakra-ui/react';

import { ContentBlock } from '../ContentBlock.component';
import { HasOneHandlerProps } from './types/documentDataViewHandlerProps';
import { ExistingValuesCard } from './ExistingValuesCard';

const HasOneHandlerComponent = <DocumentDefinition,>({
  children,
  documentPath,
  existingValues,
}: HasOneHandlerProps<DocumentDefinition>) => (
  <>
    <Stack gap={12}>
      <ContentBlock {...existingValues.ContentBlockProps} />

      <ExistingValuesCard
        existingValues={existingValues}
        workflowDataResolverDependencies={{
          documentPath,
        }}
      />
    </Stack>
    {children}
  </>
);

export const HasOneHandler = memo(HasOneHandlerComponent);
